import parseFormattedNumber from './FormattedNumberParser'

interface ParsedItem {
  name: string;
  count: number;
  volume?: number;
  ratio?: number;
}

const parseItems = (text: string): Array<ParsedItem> => {
  return text.split("\n")
    .filter((line: string) => line.length > 0)
    .map((value: string): Array<string> => value.split("\t"))
    .filter(array => array.length >= 2)
    .map((value: Array<string>): ParsedItem => ({
      name: value[0],
      count: parseFormattedNumber(value[1]) as number,
      volume: parseFormattedNumber(value[2])
    }))
    .filter((item: ParsedItem) => item != null)
}

export type { ParsedItem }
export default parseItems
